/** The sign-in screen's layout decisions, pure so vitest can pin them (it cannot render `SignIn.tsx`). */

export type SignInMethod = 'password' | 'code'

export interface SignInLayoutInput {
  identifier: string
  method: SignInMethod
  msalConfigured: boolean
}

export interface SignInLayout {
  /** `request-code` takes an email only and never resolves a username (no enumeration), so a username cannot use the code route. */
  codeAvailable: boolean
  /** The method actually in force: a username forces `password`. */
  method: SignInMethod
  showPassword: boolean
  showMicrosoft: boolean
  showMicrosoftNotice: boolean
}

export function looksLikeEmail(identifier: string): boolean {
  return /^[^\s@]+@[^\s@]+$/.test(identifier.trim())
}

export function signInLayout({ identifier, method, msalConfigured }: SignInLayoutInput): SignInLayout {
  const codeAvailable = looksLikeEmail(identifier)
  const effective: SignInMethod = codeAvailable ? method : 'password'
  return {
    codeAvailable,
    method: effective,
    showPassword: effective === 'password',
    showMicrosoft: msalConfigured,
    showMicrosoftNotice: !msalConfigured,
  }
}
